import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CmsLink, CmsLinkLocation } from '@/models/cms';
import { shouldShowRewards } from '@/helpers';
import { WebInteraction } from '@/services/analytics/platforms/adobe-analytics/models';
import { getHeaderLinkInteraction } from '@/services/analytics/platforms/adobe-analytics/helpers';

@Component({
    name: 'CmgNavItem',
})

export default class NavItem extends Vue {
    @Prop({ required: true, type: Object })
    navItem!: CmsLink;

    get isExternalLink(): boolean {
        return this.navItem.location == CmsLinkLocation.External;
    }

    get shouldHighlightExternalLink(): boolean {
        return this.isExternalLink && this.navItem.url == this.$router.currentRoute.path;
    }
    
    get isDeepNutritionLink(): boolean {
        return !this.isExternalLink && this.$router.currentRoute.path.indexOf('nutrition-calculator') > -1;
    }

    onClick(event: any) {
        const siteCountryCode = this.$appStore.state.ui.countryProfile.countryCode;
        const isGuest = !this.$services.customer.isLoggedIn();
        const isRewardsLink = this.navItem.type == 'text' && this.navItem.text == 'Rewards';

        const webInteraction: WebInteraction = getHeaderLinkInteraction(event.target.textContent.toLowerCase());
        this.$services.analytics.addLinkClickedEventToStore(webInteraction);
                
        if (isRewardsLink && shouldShowRewards(siteCountryCode) && isGuest) {
          event.preventDefault();
          window.location.href = `${window.location.origin}${this.$services.config.getRewardsPath()}`;
        }
    }
}
